/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#signature-canvas[_ngcontent-%COMP%]{background-color:#fff;box-shadow:inset 2px 2px 4px rgba(0,0,0,.2);margin-bottom:20px}\n/*# sourceMappingURL=signature-dialog.component.css.map*/"];
export { styles as styles };
